/* Keep the stock line below the price limit when the selected variant changes. */
if (!customElements.get('ayaq-pdp-stock')) {
  customElements.define(
    'ayaq-pdp-stock',
    class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const section = this.closest('.ayaq-pdp');
        this.picker = section?.querySelector('variant-radios, variant-selects');
        this.controller = new window.AbortController();
        section?.addEventListener(
          'change',
          () => {
            const variant = this.picker?.currentVariant;
            if (typeof variant?.price === 'number') {
              this.hidden = variant.price >= Number(this.dataset.priceLimit);
            }
          },
          { signal: this.controller.signal },
        );
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    },
  );
}
